import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type PersonModel from 'tio-data/models/person';
import type { LoanSummary } from 'tio-common/types/loan-summary';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type SessionContextService from 'tio-employee/services/session-context';
import { getLoanSummaryRequest } from 'tio-common/requests/user';

const EMPTY_LOAN_SUMMARY: LoanSummary = { summaryByLoanType: [], errors: [] };

export default class AuthenticatedRepayingStudentDebtRepaymentStrategyFinderDashboardIndexRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  async model() {
    const userId = this.sessionContext.user.id;
    const personId = this.sessionContext.user.person.id as string;

    // Use allSettled so individual API failures don't crash the entire page
    const [loanSummaryResult, recsResult, personResult] = await Promise.allSettled([
      userId
        ? this.store.request(getLoanSummaryRequest(userId))
        : Promise.resolve({ content: EMPTY_LOAN_SUMMARY }),
      this.store.query('recommendation', {
        filter: { user: userId, 'requesting-app': 'STRATEGY_FINDER' },
        include: 'user',
        sort: '-created-at',
        page: { offset: 0, limit: 3 },
      }),
      this.store.findRecord<PersonModel>('person', personId, {
        include: 'accounts.financial-institution,accounts.loans,user.answer-profile',
        reload: true,
      }),
    ]);

    const loanSummary =
      loanSummaryResult.status === 'fulfilled'
        ? ((loanSummaryResult.value.content as LoanSummary | undefined) ?? EMPTY_LOAN_SUMMARY)
        : EMPTY_LOAN_SUMMARY;
    const allRecommendations = recsResult.status === 'fulfilled' ? recsResult.value : [];
    const person = personResult.status === 'fulfilled' ? personResult.value : null;

    return {
      accounts: person?.accounts ?? [],
      allRecommendations,
      loanSummary,
      mostRecentRecommendation: allRecommendations?.[0],
      person,
      user: person?.user ?? null,
    };
  }
}
